import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { AdobeSignIcon, AdobeSignSearchResultIcon } from './icon';

export const adobeSignConfig: ThirdPartyConfig = {
	displayName: 'Adobe Sign',
	id: 'adobe-sign',
	resourceType: ProductResourceTypes3P.AdobeSign,
	icon: get3PLogo(AdobeSignIcon, 'Adobe Sign', 'medium'),
	searchResultIcon: get3PLogo(AdobeSignSearchResultIcon, 'Adobe Sign', 'large'),
	integrationAri: 'ari:cloud:platform::integration/adobe',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	requiresOauth: true,
	isEnabled: () => true,
};
